import React, { useEffect, useState, useContext } from 'react';
import { Link } from "react-router-dom"
import { useAuthenticator } from '@aws-amplify/ui-react';
import Button from '../../components/Button/Button'
import { ReviewsCarousel } from '../../components/ReviewsCarousel/ReviewsCarousel';
import { ArrowRight } from 'react-feather';
import { Auth } from 'aws-amplify';
import { useNavigate, useLocation } from 'react-router';
import { UserContext } from '../../Utils/UserContext';
import consumerProfileService from '../../services/consumerProfile.service';
import '../Register/Register.scss'
import '@aws-amplify/ui-react/styles.css';
import advisorProfileService from '../../services/advisorProfile.service';
import firmAdminService from '../../services/firmAdmin.service';
import ErrorBanner from '../../components/ErrorBanner/ErrorBanner';
import ClipLoader from "react-spinners/ClipLoader";
import ForgotPasswordForm from '../../components/Forms/ForgotPasswordForm/ForgotPasswordForm';
import FormModal from '../../components/Modals/FormModal';
import FormModalNotCloseable from '../../components/Modals/FormModalNotCloseable';
import DisableAccountForm from '../../components/Forms/DisableAccountForm/DisableAccountForm';
import useGA4event from '../../Utils/useGA4events';
import useMixPanelEvent from '../../Utils/MixPanel';

export default function SignIn(props) {

    const gaEventTrack = useGA4event("Sign In Page");
    const mixpanelTrack = useMixPanelEvent();

    const location = useLocation();


    const { user, setUser } = useContext(UserContext);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setErrors] = useState('');
    const [disabled, setDisabled] = useState(true);
    const [showErrorBanner, setShowErrorBanner] = useState(false);
    const [errorText, setErrorText] = useState('Something went wrong. Please try again.');
    const [loading, setLoading] = useState(false);
    const [redirectUri, setRedirectUri] = useState(null);
    const [showEnableAccountModal, setShowEnableAccountModal] = useState(false);
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
    const [advisorProfileRedirect] = useState(JSON.parse(localStorage.getItem('advisorProfileRedirect')));

    const { route } = useAuthenticator((context) => [context.route]);
    const navigate = useNavigate();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const tempRedirectUri = queryParams.get('redirectUri');
        if (tempRedirectUri) {
            setRedirectUri(tempRedirectUri);
        }

    }, [])

    useEffect(async () => {
        if (route === 'authenticated') {
            setLoading(true)
            let user = {}
            try {
                user = await setUserInfo()
                if (!user.accountEnabled) {
                    setShowEnableAccountModal(true);
                } else {

                    if (user.groups.includes('Advisor')) {
                        window.location = `/advisor-profile/${user.id}/${user.firstName}-${user.lastName}/`
                    } else if (user.groups.includes('FirmAdmin')) {
                        window.location = `/firmAdmin-dashboard`;
                    }
                    else {
                        // need to check if they have a profile, if not then redierect to consumer details page.
                        if (user.firstName) {
                            window.location = `/dashboard`;
                        } else {
                            window.location = `/details/${user.id}/${user.email}`;
                        }
                    }
                }
            } catch (error) {
                console.log(error);
                await Auth.signOut();
                setUser(null);
            } finally {
                setLoading(false)
            }

        }
    }, [route, navigate]);

    useEffect(() => {
        if (email === '' || password === '') {
            setDisabled(true)
        } else {
            setDisabled(false)
        }

    }, [email, password]);


    async function setUserInfo() {
        const user = await Auth.currentAuthenticatedUser();
        const userGroups = user.signInUserSession.accessToken.payload["cognito:groups"];
        const userId = user.attributes["custom:id"];
        const userEmail = user.attributes.email;
        const userName = user.username;

        let currentUserInfo;
        try {
            if (userGroups.includes('Advisor')) {
                currentUserInfo = await advisorProfileService.getOne(userId);
                currentUserInfo.id = currentUserInfo.professionalId;
            } else if (userGroups.includes('FirmAdmin')) {
                currentUserInfo = await firmAdminService.getOne(userId);
                currentUserInfo.id = currentUserInfo.id;
            }
            else {
                currentUserInfo = await consumerProfileService.getOne(userEmail);
                currentUserInfo.id = currentUserInfo.consumerId;
            }

            const userObj = {
                groups: userGroups,
                email: userEmail,
                userName,
                id: currentUserInfo.id,
                firmID: currentUserInfo.firmId,
                firstName: currentUserInfo.firstName,
                lastName: currentUserInfo.lastName,
                phoneNumber: currentUserInfo.phoneNumber,
                hasLoggedIn: currentUserInfo.hasLoggedIn,
                accountEnabled: currentUserInfo.accountEnabled,
            }
            setUser(userObj);
            return userObj;
        } catch {
            throw (new Error('Something went wrong. Please try again.'));
        }
    };

    async function setUserSignedInOnce(type, id) {
        const myInit = {
            body: {
                columnData: [
                    {
                        hasLoggedIn: 1
                    }
                ]
            }
        };
        try {
            if (type == 'advisor') {
                await advisorProfileService.update(id, myInit);
            } else if (type === 'firmAdmin') {
                await firmAdminService.update(id, myInit);
            } else {
                await consumerProfileService.update(id, myInit);
            }
        } catch (error) {
            console.log(error);
            throw (new Error('Something went wrong. Please try again.'));
        }
    }

    async function signIn(event) {
        event.preventDefault();
        setErrors('')
        setLoading(true)

        try {
            setDisabled(true);
            setShowErrorBanner(false);
            await Auth.signIn(email, password)
            const user = await setUserInfo();
            if (!user.accountEnabled) {
                setShowEnableAccountModal(true);
            } else {
                if (user.groups.includes('Advisor')) {
                    gaEventTrack('Sign In', 'Advisor')
                    mixpanelTrack('Advisor sign in', 'Email', user.email);
                    if (user.hasLoggedIn) {
                        window.location = redirectUri ? redirectUri : `/advisor-profile/${user.id}/${user.firstName}-${user.lastName}/`;
                    } else {
                        await setUserSignedInOnce('advisor', user.id);
                        window.location = `/confirmInfo/${user.id}`
                    }
                } else if (user.groups.includes('FirmAdmin')) {
                    gaEventTrack('Sign In', 'Firm Admin')
                    mixpanelTrack('Firm Admin sign in', 'Email', user.email);
                    if (user.hasLoggedIn) {
                        window.location = redirectUri ? redirectUri : `/firmAdmin-dashboard`; 
                    } else {
                        await setUserSignedInOnce('firmAdmin', user.id);
                        window.location = `/firmAdmin-dashboard`;
                    }
                } else {
                    gaEventTrack('Sign In', 'Consumer')
                    mixpanelTrack('Consumer sign in', 'Email', user.email);
                    if (advisorProfileRedirect && user.hasLoggedIn) {
                        window.location = `${advisorProfileRedirect}`;
                    }
                    else if (user.hasLoggedIn) {
                        window.location = redirectUri ? redirectUri : `/dashboard`;
                    } else {
                        await setUserSignedInOnce('consumer', user.id);
                        window.location = `/details/${user.id}/${user.email}`;
                    }
                }
            }
        } catch (err) {
            console.log(err);
            setErrorText(err.message)
            setShowErrorBanner(true);
        } finally {
            setDisabled(false);
            setLoading(false)
        }
    }

    async function handleCloseEnableAccountForm() {
        setShowEnableAccountModal(false);
        if (user.groups.includes('Advisor')) {
            if (user.hasLoggedIn) {
                window.location = redirectUri ? redirectUri : `/advisor-profile/${user.id}/${user.firstName}-${user.lastName}/`;
            } else {
                await setUserSignedInOnce('advisor', user.id);
                window.location = `/confirmInfo/${user.id}`
            }
        } else if (user.groups.includes('FirmAdmin')) {
            if (user.hasLoggedIn) {
                window.location = redirectUri ? redirectUri : `/dashboard`; //TODO FIX TO FIRM ADMIN LOGIN PAGE
            } else {
                await setUserSignedInOnce('firmAdmin', user.id);
                window.location = `/dashboard`; //TODO FIX TO FIRM ADMIN LOGIN PAGE
            }
        } else {
            if (user.hasLoggedIn) {
                window.location = redirectUri ? redirectUri : `/dashboard`;
            } else {
                await setUserSignedInOnce('consumer', user.id);
                window.location = `/details/${user.id}/${user.email}`;
            }
        }
    }


    return (
        <>
            {loading && <div className='spinnerContainer'>
                <ClipLoader color={'var(--adfi_blue500)'} loading={loading} size={100} />
            </div>}
            {showForgotPasswordModal && <FormModal onClose={() => setShowForgotPasswordModal(false)} show={showForgotPasswordModal} title={'Reset Password'}>
                <ForgotPasswordForm></ForgotPasswordForm>
            </FormModal>}
            {user && <FormModalNotCloseable show={showEnableAccountModal} title={"Your Account is Disabled - Re-enable it to log in."}>
                <DisableAccountForm user={user} enable={true} onClose={() => handleCloseEnableAccountForm()}></DisableAccountForm>
            </FormModalNotCloseable>}
            <div className='page-container'>
                <div className="register-container left">
                    <div className='logo-container'>
                        <a href="https://www.advisorfinder.com" rel="noopener">
                            <img loading="lazy" src='/AdFi-logo-name.svg' alt="/AdFi-logo-name.svg" className='register-logo' />
                        </a>
                    </div>
                    <div className='form-container'>
                        <img loading="lazy" className="info-image" src="/sign-up-email.svg" alt="/sign-up-email.svg" />
                        <h1 className='register-header'>Welcome back!</h1>
                        <p className='register-paragraph'>First time here? <Link to="/signup">Join AdvisorFinder</Link> or <Link to="/advisor-apply">apply as an advisor.</Link></p>
                        <form className="register-form" onSubmit={signIn}>
                            <div className="input-container">
                                <input
                                    className="input full"
                                    id="email"
                                    placeholder="Email"
                                    style={{ maxWidth: '400px' }}
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="input-container">
                                <input
                                    className="input full"
                                    id="password"
                                    placeholder="Password"
                                    type="password"
                                    style={{ maxWidth: '400px' }}
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                            </div>
                            <div className="forgotPasword" onClick={() => setShowForgotPasswordModal(true)}>Forgot Password?</div>
                            {error !== '' && <p className='error-message' style={{ justifyContent: 'center', paddingTop: '10px' }}>{error}</p>}
                            <div className="input-container">
                                <Button color="clear-button large" type="submit" disabled={disabled}>Sign In<ArrowRight size={20} /></Button>
                            </div>
                        </form>
                        {showErrorBanner && <ErrorBanner onClick={() => setShowErrorBanner(false)}>{errorText}</ErrorBanner>}
                    </div>
                </div>
                <div className="register-container right">
                    <ReviewsCarousel />
                </div>
            </div>
        </>
    );
}